import { ApplicationService } from '~/services/core/application.service'

// TODO:
//  - Create blog interfaces to use as return type
export class BlogService extends ApplicationService {
  get baseUrl () {
    return this.runtimeConfig.BASE_API_URL
  }

  getArticlesList (payload: any): Promise<any> {
    return this.get('/api/blogs/', payload)
  }

  getArticleBySlug (slug: string): Promise<any> {
    return this.get(`/api/blogs/${slug}/`)
  }
}
